<template>
  <div class="bao">
    <el-card class="box-card contaier">
      <div class="title">
        <span class="perInfo">{{ $t("sidebar.collected") }}</span>
      </div>

      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :label="$t('collected.exhibition')" name="first"
          ><Exhibition
        /></el-tab-pane>
        <el-tab-pane :label="$t('collected.exhibits')" name="second"
          ><Product
        /></el-tab-pane>
        <el-tab-pane :label="$t('collected.live')" name="third"
          ><Live
        /></el-tab-pane>
        <el-tab-pane :label="$t('collected.activity')" name="fourth"
          ><Activity
        /></el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>
<script>
import Exhibition from "./components/exhibition.vue";
import Product from "./components/product.vue";
import Live from "./components/live.vue";
import Activity from "./components/activity.vue";
export default {
  data() {
    return {
      activeName: "first",
      tab: "",
    };
  },
  components: { Exhibition, Product, Live, Activity },
  methods: {
    handleClick(tab) {
      this.tab = tab.name;
      console.log(tab);
    },
  },

  //组合监听路由参数变化
  watch: {
    $route() {
      const id = this.$route.query.positionId;
      this.activeName = id;
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      const id = vm.$route.query.positionId;
      vm.activeName = id;
    });
  },
};
</script>
<style lang="scss" scoped>
.bao {
  padding-top: 50px;
}
.contaier {
  position: relative;
  padding: 10px 10px 0px 10px;
  background-color: #f0f2f5;
  .title {
    display: flex;
    justify-content: flex-start;
    padding-bottom: 20px;
    background-color: white;
    padding-top: 20px;
    padding: 20px 15px 0px 15px;
    .perInfo {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 25px;
    }
  }
  .main {
    margin-top: 20px;
    display: flex;
    position: relative;
    .el-tabs {
      width: 100%;
    }
    .change {
      position: absolute;
      right: 5px;
      top: 0;
      width: 88px;
      height: 32px;
      background: #ffffff;
      border: 1px solid #d9d9d9;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      padding: 5px 20px;
      box-sizing: border-box;
      border-radius: 4px;
    }
    .change:hover {
      cursor: pointer;
      color: #006fb8;
    }
  }
}
</style>
<style scoped>
.el-tabs >>> .el-tabs__item.is-active {
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #006fb8;
}
.el-tabs >>> .el-tabs__item:hover {
  color: #006fb8;
  cursor: pointer;
}
.el-tabs >>> .el-tabs__item {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  padding: 0 10px;
  min-width: 58px;
  text-align: right;

}
.el-tabs >>> .el-tabs__nav-wrap::after {
  height: 1px;
  background: #e8e8e8;
}
.el-tabs >>> .el-tabs__nav-wrap::after:hover {
  color: #006fb8;
}
.el-tabs >>> .el-tabs__active-bar {
  height: 2px;
  background-color: #006fb8;
  min-width: 58px;

 
}
.el-tabs >>> .el-tabs__nav-wrap::after {
  position: static !important;
}
.bao >>> .el-card__body {
  padding: 0px;
}
.bao >>> .el-card__body {
  padding: 0px;
  /* background: #f0f2f5; */
}

.bao >>> .el-tabs__header {
  background-color: white;
  padding: 0px 15px;
}
</style>
